// test2398
(2398 && 0);
